import { HUE_ORDER, type HueName } from '@habishine/client-core';

import { hueVar } from '../theme/hues';

/* seven discs; the chosen one wears a ring of its own tint and a tick */
export function HuePicker({ value, onChange }: { value: HueName; onChange: (h: HueName) => void }) {
  return (
    <div className="flex gap-2.5" role="radiogroup" aria-label="Colour">
      {HUE_ORDER.map((h) => {
        const on = value === h;
        return (
          <button
            key={h}
            type="button"
            role="radio"
            aria-checked={on}
            aria-label={h}
            onClick={() => onChange(h)}
            className="flex h-8 w-8 items-center justify-center rounded-full text-white transition-transform duration-150 hover:scale-110 active:scale-95"
            style={{ background: hueVar(h, 'c'), boxShadow: on ? `0 0 0 3px var(--card), 0 0 0 5px ${hueVar(h, 'c')}` : 'none' }}
          >
            {on ? (
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden><path d="M5 12.5l4.5 4.5L19 7.5" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
